export const FilterForm = {
	showArrow: false,
	title: {
		type: "div",
		className: "d-flex",
		children: [
			{
				type: "icon",
				antIcon: "FilterOutlined",
				style: { marginRight: "6px", paddingTop: "4px" },
			},
			{
				type: "text",
				content: "{{FILTER_BY}}",
			},
		],
	},
	children: [
		{
			type: "form",
			formRef: "filterForm",
			onFinish: "onSubmitFilterForm",
			children: [
				{
					type: "div",
					className: "w-100",
					children: [
						{
							type: "row",
							gutter: 8,
							children: [
								{
									type: "col",
									span: 12,
									children: [
										{
											type: "select",
											name: "status",
											label: "{{STATUS}}",
											inputConfig: {
												placeholder: "{{STATUS}}",
												size: "large",
												options: [
													{ value: "pending", label: "Pending" },
													{ value: "approved", label: "Approved" },
													{ value: "rejected", label: "Rejected" },
												]
											},
										},
									],
								},
								{
									type: "col",
									span: 12,
									children: [
										{
											type: "select",
											name: "type",
											label: "{{TYPE}}",
											inputConfig: {
												placeholder: "{{TYPE}}",
												size: "large",
												options: [
													{ value: "withdraw", label: "Withdraw" },
													{ value: "security_deposit", label: "Security Deposit" },
													{ value: "tax", label: "Tax" },
													{ value: "income", label: "Income" },
													{ value: "service_fee", label: "Service Fee" },
													{ value: "rank_up_bonus", label: "Rank Up Bonus"},
													{ value: "refund", label: "Refund"}
												]
											},
										},
									],
								},
							],
						},
						{
							type: "div",
							className: "d-flex justify-content-end",
							children: [
								{
									type: "button",
									buttonType: "text",
									className: "mr-2 my-1",
									actionKey: "RESET_FILTER",
									children: [
										{
											type: "text",
											content: "{{CLEAR}}"
										},
									],
								},
								{
									type: "button",
									htmlType: "submit",
									buttonType: "text",
									className: "custom-color my-1",
									style: {
										backgroundColor: "$quaternary",
										color: "#ffffff",
									},
									children: [
										{
											type: "text",
											content: "{{SEARCH}}"
										},
									],
								},
							],
						},
					],
				},
			],
		},
	]
}